var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonalisation = function SvgPersonalisation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_394_699",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H22V22H2V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_394_699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.56781 18.6422C7.61273 17.9796 7.35484 17.3851 6.90918 16.9395C6.01348 16.0439 4.68672 16.0781 3.86977 16.7715C2.95547 17.5475 3.00523 18.4063 3.24617 19.1216C3.76824 20.6714 2.37988 21.468 2.37988 21.468C3.22477 21.8617 5.18957 21.8407 6.29707 20.856C6.6548 20.5379 6.92906 20.2166 7.13 19.899",
    stroke: "#CC7722",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1785 4.47838L16.1082 5.996C12.6241 8.55006 9.65566 11.7414 7.36035 15.4008V15.4009",
    stroke: "#CC7722",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50195 16.5406L8.5116 16.5346C12.1663 14.2443 15.3545 11.283 17.9078 7.80733L20.9085 3.72241L20.1892 3.00436L19.3212 3.64065",
    stroke: "#CC7722",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53838 17.5015C6.93151 16.8951 7.00475 16.969 6.39749 16.3622C6.13163 16.0966 6.1319 15.6661 6.39788 15.4006C6.66362 15.1352 7.0944 15.1353 7.3601 15.4008L8.50065 16.5397C8.76663 16.8054 8.76639 17.2364 8.50006 17.5019C8.2342 17.7669 7.80393 17.7668 7.53838 17.5015Z",
    stroke: "#CC7722",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4712 3.16046L20.9088 3.72241L20.1895 3.0044L20.7527 2.44163C20.9511 2.24343 21.2725 2.24331 21.471 2.44144C21.6698 2.63987 21.6699 2.96194 21.4712 3.16046Z",
    stroke: "#CC7722",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7236 10.9062L13.0023 13.1849",
    stroke: "#CC7722",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgPersonalisation;